export default function HealthIcon(
  props: Pick<React.SVGProps<SVGSVGElement>, "fill" | "fillOpacity">,
) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.12658 5.97079C5.95075 5.08891 4.30539 5.20584 3.26609 6.24514C2.11269 7.39854 2.11269 9.26857 3.26609 10.422L8.28073 15.4366C9.22979 16.3857 10.7685 16.3857 11.7176 15.4366L16.7322 10.422C17.8856 9.26857 17.8856 7.39854 16.7322 6.24514C15.6929 5.20584 14.0476 5.08891 12.8717 5.97079L10.7064 7.5948C10.2873 7.90913 9.71103 7.90913 9.29193 7.5948L7.12658 5.97079ZM2.08758 5.06663C3.71336 3.44085 6.28721 3.25793 8.12658 4.63745L9.99916 6.04189L11.8717 4.63745C13.7111 3.25793 16.285 3.44085 17.9107 5.06663C19.715 6.8709 19.715 9.79621 17.9107 11.6005L12.8961 16.6151C11.2962 18.2151 8.70216 18.2151 7.10222 16.6151L2.08758 11.6005C0.283307 9.79621 0.283306 6.8709 2.08758 5.06663Z"
        fill={props.fill || "#0F1324"}
        fillOpacity={props.fillOpacity || "0.6"}
      />
    </svg>
  );
}
